import { API_URLS, } from "@constants";
import { dehydrate, hydrate, } from "@hydra";
import type { IBracketStore, } from "@store";
import { fetchApiResponseHandler } from "@utils";
import { produce, } from 'immer';
import type { StateCreator, } from "zustand";
import type { IPointsSlice, PointsGetResult,} from "./types";
import { awaitTruthy, loadAtTimeout, } from "@store/helpers";


export const createPointsSlice: StateCreator<IBracketStore, [], [], IPointsSlice> = (set, get) => {


	const fetch = async ( force = false, ) => {

		const { ready, fetching, } = get().bars.points;
		if(!force && (ready || fetching)) {
			return;
		}


		set(produce(state => {
			state.bars.points.ready = false;
			state.bars.points.fetching = true;
			state.bars.points.isLoading = true;
			state.bars.points.isError = false;
			state.bars.points.error = null;
		}));

		try {

			const { useStore, } = await import("@store/useStore");
			await awaitTruthy(useStore, state => state.wallet.ready);
			const { fetched, props, } = await hydrate("points");

			if(fetched) {
				set(produce(state => {
					Object.entries(props).forEach(([key, value]) => {
						// @ts-ignore -- fix later
						if(key in state.bars.points) {
							// @ts-ignore -- fix later
							state.bars.points[key] = value;
							state.bars.points.isLoading = false;
						}
					});
				}));
			}

			const data = await fetchApiResponseHandler<PointsGetResult>({
				url: `${API_URLS.BARS}/points?address=${get().wallet.address}`,
				signal: new AbortController().signal,
				onAbort: () => console.log("points request aborted"),
			});

			set(produce(state => {
				state.bars.points.data = data;
				state.bars.points.isLoading = false;
				state.bars.points.ready = true;
				state.bars.points.fetching = false;
			}));

			dehydrate("points", { data, });


		}
		catch (error) {

			set(produce(state => {
				state.bars.points.ready = true;
				state.bars.points.fetching = false;
				state.bars.points.isLoading = false;
				state.bars.points.isError = true;
				state.bars.points.error = error instanceof Error ? error : new Error("An unknown error occurred");
			}));

		}

	};


	const update = (updater: (oldData: PointsGetResult | null) => PointsGetResult) => {
		set(produce(state => {
			state.bars.points.data = updater(state.bars.points.data);
		}));
	};


	const setData = (data: PointsGetResult) => {
		set(produce(state => {
			state.bars.points.data = data;
		}));
	};


	const setError = (error: Error) => {
		set(produce(state => {
			state.bars.points.isError = true;
			state.bars.points.error = error;
		}));
	};


	const reset = () => {
		console.warn("createPointsSlice::reset not implemented");
	};


	const resetAsync = async () => {
		console.warn("createPointsSlice::resetAsync not implemented");
	};


	loadAtTimeout("bars.points", 2000);


	return {
		ready: false,
		fetching: false,
		data: null,
		isLoading: false,
		isError: false,
		error: null,
		fetch,
		reset,
		resetAsync,
		update,
		setData,
		setError,
	};

};
